import {gsap, smoother, ScrollTrigger} from "../Utility/gsap";
import Dom from '../utility/dom';

class imageTicker {
  constructor(el) {
    this.el = el;
    this.innerEl = el.querySelector('.image_ticker__inner');
    this.direction = el.classList.contains('left') ? -1 : 1;
    this.speed = el.getAttribute('data-ticker-speed');
    this.tweenToX = (this.direction * 100) + '%';
    
    // Play the static ticker animation
    this.tween = this.setTween();
    
    // Watch to accelerate the ticker animation timing
    this.scrollTrigger = this.setScrollTrigger();
    this.velocity = 0;
    this.timeScaleOffset = 0;
  }

  setTween(){
    const tween = gsap.to( this.innerEl, {
      x: this.tweenToX,
      duration: this.speed,
      ease: 'linear',
      repeat: -1
    });

    return tween;
  }

  setScrollTrigger(){
    let sliderScrollTrigger = null;

    if(Dom.prefersMotion){
      sliderScrollTrigger = ScrollTrigger.create({
        trigger: this.el,
        start: `top bottom`,
        end: `bottom top`,
        onUpdate: () => {
          this.timeScaleOffset = this.getScrollVelocity();
          this.tween.timeScale(1+this.timeScaleOffset);
        }
      });
    }

    return sliderScrollTrigger;
  }

  getScrollVelocity() {
    // Ensure velocity is a positive number
    let velocity = smoother ? smoother.getVelocity() : 0;
    this.velocity = velocity < 0 ? velocity * -1 : velocity;

    // Set acceleration based on velocity, tempered.
    const acceleration = this.velocity * .007;

    return acceleration;
  }
}

const InitImageTicker = () => {
  const tickers = document.querySelectorAll('.image_ticker');
  
  if(tickers){
    tickers.forEach(tickerEl => {
      tickerEl.ticker = new imageTicker(tickerEl);
    });
  };
}

export {InitImageTicker};